'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyle = {
  textStyle: 'heading',
  mt: 0,
  mb: 2
};
var sizes = {
  display: {
    fontSize: {
      md: '3xl',
      base: '2xl'
    },
    fontWeight: 'bold'
  },
  subline: {
    fontSize: {
      md: 'xl',
      base: 'md'
    },
    color: 'gray.400'
  },
  h1: {
    fontSize: '2xl'
  },
  h2: {
    fontSize: 'xl'
  },
  h3: {
    fontSize: 'lg'
  },
  h4: {
    fontSize: 'md'
  },
  h5: {
    fontSize: 'sm'
  }
};
var defaultProps = {
  size: 'h2'
};
var Heading = {
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Heading;